<template>
     <v-row no-gutters>
        <v-col>
            <v-toolbar dense :elevation="0">
                <div class="text-primary-700" style="font-weight: 700; display: grid;">
                    <span style="font-size: large">Deals</span>  
                    <span style="margin-top:-10px">
                    <a href="https://rp-database.com/docs/features/deals" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
                    </span>
                </div>
                <v-row>
                    <v-col>
                        <v-btn-toggle class="ml-2"
                                        v-model="tableType"
                                        tile
                                        group
                                        mandatory

                        >   
                            <v-btn value="lettings">
                                Lettings
                            </v-btn>
                            <v-btn value="sales">
                                Sales
                            </v-btn>

                            
                        </v-btn-toggle>
                    </v-col>
                </v-row>    
                <div class="flex-grow-1"></div>
                <!-- <v-btn color="primary float-right" outlined>Manage Deals</v-btn> -->
                <v-checkbox
                    v-model="includeAdminDeals"
                    label="Hide Public"
                    class="mr-4"
                    hide-details
                    @change="fetchDeals"
                ></v-checkbox>


                <div class="mr-4" style="max-width: 350px; width: 100%;">
                    <v-menu offset-y persistent permanent content-class="mt-2" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dealFromText"
                                append-icon="mdi-calendar"
                                class="rpd-datepicker-text"
                                label="Effective Date From"
                                outlined
                                dense
                                readonly
                                hide-details
                                v-on="on"
                            >
                                <!-- append icon -->
                                <template v-slot:append>
                                    <transition name="fade">
                                        <v-btn v-if="dealFromDate" class="rpd-datepicker-btn mr-1" icon @click="dealFromDate = null"><v-icon>mdi-close</v-icon></v-btn>
                                    </transition>
                                    <v-btn class="rpd-datepicker-btn" icon v-on="on"><v-icon>mdi-calendar</v-icon></v-btn>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker style="width: 100%;" 
                            v-model="dealFromDate" 
                            persistent
                        ></v-date-picker>
                    </v-menu>
                </div>
                <div style="max-width: 350px; width: 100%;">
                    <v-menu offset-y persistent permanent content-class="mt-2" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dealToText"
                                append-icon="mdi-calendar"
                                class="rpd-datepicker-text"
                                label="Effective Date To"
                                outlined
                                dense
                                readonly
                                hide-details
                                v-on="on"
                            >
                                <!-- append icon -->
                                <template v-slot:append>
                                    <transition name="fade">
                                        <v-btn v-if="dealToDate" class="rpd-datepicker-btn mr-1" icon @click="dealToDate = null"><v-icon>mdi-close</v-icon></v-btn>
                                    </transition>
                                    <v-btn class="rpd-datepicker-btn" icon v-on="on"><v-icon>mdi-calendar</v-icon></v-btn>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker style="width: 100%;" 
                            v-model="dealToDate" 
                            persistent
                        ></v-date-picker>
                    </v-menu>
                </div>
                
            </v-toolbar>
            <v-card-text>
                <v-data-table
                    style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;"
                    :headers="headers"
                    :items="deals"
                    :search="search"
                    :options.sync="pagination"
                    :loading="loading"
                    :server-items-length="totalRecords"
                    :items-per-page.sync="itemsPerPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :custom-sort="sortData"
                    :page.sync="page"
                    :multi-sort="false"
                    :footer-props="{'items-per-page-options': [50, 100, 500],}"
                    @update:options="fetchDeals"
                >
                    <template v-slot:body="{ items }">
                        <tbody v-if="initLoader">
                            <tr v-for="n in 12" :key="n">
                                <td class="px-0 table-loading"  :colspan="headers.length">
                                    <v-skeleton-loader
                                    type="list-item"
                                    ></v-skeleton-loader>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="items.length > 0">
                            <tr v-for="item in items" :key="item.id" class="data-table__row">
                                <td>
                                    <a @click="$refs.editUserDialog.showDialog(item.creator.data.id)">
                                        {{ item.creator.data.name }}
                                        <v-tooltip bottom v-if="item.creator.data.core_id">
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-icon :color="verifyRetailer(item.creator.data).icon"
                                                v-bind="attrs" v-on="on">
                                                mdi-checkbox-marked-circle-outline
                                            </v-icon>
                                            </template>
                                            <span>{{ verifyRetailer(item.creator.data).tooltip }}</span>
                                        </v-tooltip>
                                    </a>
                                </td>
                                <td>
                                    <a v-if="item.scheme_id" @click="viewScheme(item.scheme_id)">
                                        {{ item.scheme.data.name }}
                                    </a>
                                    <a v-else-if="item.property.data.scheme_id" @click="viewScheme(item.property.data.scheme_id)">
                                        {{ item.property.data.scheme.data.name }}
                                    </a>
                                </td>
                                <td>
                                    <a v-if="item.property_id" @click="viewProperty(item.property_id)">
                                        {{ item.property.data.address.data.full_address }}
                                    </a>
                                </td>
                                <td style="text-transform: capitalize;">
                                    <span v-if="item.sale_type && tableType == 'sales'">{{ formatData(item.sale_type) }}</span>
                                    <span v-else-if="item.deal_type && tableType != 'sales'">{{ formatData(item.deal_type) }}</span>
                                </td>
                                <td v-if="tableType === 'lettings'">
                                    <!-- prev tenant -->
                                    <a v-if="item.prev_tenant.data.name" @click="$refs.editCompanyDialog.showDialog(item.prev_tenant.data.id)">
                                        {{ item.prev_tenant.data.name }}
                                        <v-tooltip bottom v-if="item.prev_tenant.data.core_id">
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-icon :color="verifyRetailer(item.prev_tenant.data).icon"
                                                v-bind="attrs" v-on="on">
                                                mdi-checkbox-marked-circle-outline
                                            </v-icon>
                                            </template>
                                            <span>{{ verifyRetailer(item.prev_tenant.data).tooltip }}</span>
                                        </v-tooltip>
                                    </a>
                                    <!-- else show vacant -->
                                    <span v-else class="grey--text">Vacant</span>
                                </td>
                                <td v-if="tableType === 'lettings'">
                                    <a v-if="item.tenant.data.name" @click="$refs.editCompanyDialog.showDialog(item.tenant.data.id)">
                                        {{ item.tenant.data.name }}
                                        <v-tooltip bottom v-if="item.tenant.data.core_id">
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-icon :color="verifyRetailer(item.tenant.data).icon"
                                                v-bind="attrs" v-on="on">
                                                mdi-checkbox-marked-circle-outline
                                            </v-icon>
                                            </template>
                                            <span>{{ verifyRetailer(item.tenant.data).tooltip }}</span>
                                        </v-tooltip>
                                    </a>
                                    <span v-else class="grey--text">Vacant</span>
                                </td>
                                <td v-if="tableType === 'lettings'">
                                    <span v-if="item.property.data.nia_sqrt">
                                        {{ item.property.data.nia_sqrt }} {{ item.property.data.area_size_type }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.created_at">{{ item.created_at }}</span>
                                </td>
                                <td>
                                    <span v-if="item.effective_date && (item.deal_type == 'rent_review' || item.deal_type == 'subletting' || item.deal_type == 'tenant_change' || item.deal_type == 'tracked_retailer' || item.deal_type == 'sale')">{{ formatDate(item.effective_date) }}</span>
                                    <span v-else-if="item.lease_start_date && (item.deal_type == 'lease_renewal' || item.deal_type == 'new_letting')">{{ formatDate(item.lease_start_date) }}</span>
                                </td>
                                <td>
                                    <v-tooltip v-if="!item.client_id" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-on="on" v-bind="attrs" class="ml-1" color="blue">mdi-web</v-icon>
                                            </template>
                                            <span>This Deal is Public</span>
                                        </v-tooltip>
                                    <v-tooltip v-else left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs" class="ml-1" color="grey">mdi-web</v-icon>
                                        </template>
                                        <span>This Deal is Private</span>
                                    </v-tooltip>
                                </td>
                                <td style="text-align: center;">
                                    <v-icon class="mx-1" small @click="viewDeal(item.id)">mdi-eye</v-icon>
                                    <!-- <v-icon class="mx-1" small @click="editDeal(item.id)">mdi-pencil</v-icon> -->
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon class="mx-1" v-on="on" small @click="viewLinks(item)" >mdi-link</v-icon>
                                        </template>
                                        <span>Manage Links</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" :colspan="headers.length">
                                    No records found
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-col>
        <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
        <edit-property-dialog ref="editPropertyDialog" @updated="fetchDeals"></edit-property-dialog>
        <edit-company-dialog ref="editCompanyDialog"></edit-company-dialog>
        <edit-user-dialog ref="editUserDialog"></edit-user-dialog>
        <view-deal-dialog ref="viewDeal" /> 
        <view-links-dialog ref="viewLinks" />
        <edit-deal-dialog ref="editDealDialog" @updated="fetchDeals"></edit-deal-dialog>
    </v-row>
</template>
<script>
    import EditUserDialog from "@/components/users/editUserDialog.vue"; 
    import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
    import EditPropertyDialog from "@/components/properties/editPropertyDialog";
    import EditCompanyDialog from "@/components/companies/editCompanyDialog.vue";
    import viewDealDialog from '@/components/deals/viewDealDialog.vue';
    import  viewLinksDialog from '@/components/deals/viewDealLinks.vue';
    import editDealDialog from '@/components/deals/editDealDialog.vue';


    export default {
        components: {
            EditUserDialog,
            EditSchemeDialog,
            EditPropertyDialog,
            EditCompanyDialog,
            viewDealDialog,
            viewLinksDialog,
            editDealDialog
        },
        
        data() {
            return { 
                headers: [
                { text: 'Creator', value: 'creator.name', class:'data-table__cell' },
                    { text: 'Scheme', value: 'scheme.name', class:'data-table__cell' },
                    { text: 'Property', value: 'property.id', class:'data-table__cell' },
                    { text: 'Type', value: 'deal_type', class:'data-table__cell' },
                    { text: 'Old Tenant', value: 'prevTenant.name', class:'data-table__cell' },
                    { text: 'New Tenant', value: 'tenant.name', class:'data-table__cell' },
                    { text: 'Area', value: 'property.nia_sqrt', class:'data-table__cell' },
                    { text: 'Created at', value: 'created_at', class:'data-table__cell' },
                    { text: 'Effective Date', value: 'effective_date', class:'data-table__cell' },
                    { text: 'Public', value: 'is_public', class:'data-table', sortable:false },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false, class:'data-table__cell', width: '100px' },
                ],
                schemeHeaders: [
                    { text: 'Creator', value: 'creator.name', class:'data-table__cell' },
                    { text: 'Scheme', value: 'scheme.name', class:'data-table__cell' },
                    { text: 'Property', value: 'property.id', class:'data-table__cell' },
                    { text: 'Sale Type', value: 'sale_type', class:'data-table__cell' },
                    { text: 'Created at', value: 'created_at', class:'data-table__cell'},
                    { text: 'Effective Date', value: 'effective_date', class:'data-table__cell' },
                    { text: 'Public', value: 'is_public', class:'data-table', sortable:false },
                    { text: 'Actions', align: 'center',  value: 'actions', sortable: false, class:'data-table__cell', width: '100px' },
                ],
                lettingsHeaders: [
                    { text: 'Creator', value: 'creator.name', class:'data-table__cell' },
                    { text: 'Scheme', value: 'scheme.name', class:'data-table__cell' },
                    { text: 'Property', value: 'property.id', class:'data-table__cell' },
                    { text: 'Type', value: 'deal_type', class:'data-table__cell' },
                    { text: 'Old Tenant', value: 'prevTenant.name', class:'data-table__cell' },
                    { text: 'New Tenant', value: 'tenant.name', class:'data-table__cell' },
                    { text: 'Area', value: 'property.nia_sqrt', class:'data-table__cell' },
                    { text: 'Created at', value: 'created_at', class:'data-table__cell' },
                    { text: 'Effective Date', value: 'effective_date', class:'data-table__cell' },
                    { text: 'Public', value: 'is_public', class:'data-table', sortable:false },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false, class:'data-table__cell', width: '100px' },
                ],
                deals: [],
                search: '',
                pagination: {},
                loading: false,
                initLoader: true,
                totalRecords: 0,
                itemsPerPage: 50,
                sortBy: 'effective_date',
                sortDesc: true,
                page: 1,
                tableType: 'lettings',

                includeAdminDeals: false,
                
                dateRange: null,
                dateRangeText: '',

                dealFromDate: null,
                dealToDate: null,
                dealFromText: '',
                dealToText: '',
                
            }
        },
        methods: {
            verifyRetailer(retailer){
                let object ={
                    icon: 'grey',
                    tooltip: 'This retailer has never been verified',
                }
                if((retailer.scraper.data && retailer.scraper.data.verified_at) || retailer.scraper.verified_at){
                    if(retailer.is_verified){
                    object.icon = 'green'
                    object.tooltip = 'This retailer is verified'
                    }else{
                    object.icon = 'orange lighten-1'
                    object.tooltip = 'This retailer is not currently verified'
                    }
                }
                return object
            },

            fetchDeals(){
                this.loading = true;
                this.$http.get(`/deals`, {
                    params: {
                        include: 'scheme,property,property.address,property.scheme,user,tenant,tenant.scraper,prev_tenant.scraper,creator,links',
                        page: this.pagination.page,
                        is_owned: this.$auth.user().company.data.id,
                        include_admin_deals: this.includeAdminDeals ? undefined : true,
                        itemsPerPage: this.itemsPerPage,
                        sort_by: this.pagination.sortBy[0],
                        desc: this.pagination.sortDesc[0] ? 1 : 0,
                        search: this.search,
                        deal_type: this.tableType === 'sales' ? ['sale'] : ['lease_renewal', 'new_letting', 'rent_review', 'subletting', 'tenant_change', 'tracked_retailer'],
                        deal_from_date: this.dealFromDate,
                        deal_to_date: this.dealToDate,
                    }
                }).then(response => {
                    this.deals = response.data.data;
                    this.totalRecords = response.data.meta.pagination.total;
                    this.loading = false;
                    this.initLoader = false;
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                    this.initLoader = false;
                })
            },
            viewScheme(id) {
                this.$refs.editSchemeDialog.showDialog(id);
            },
            viewProperty(id) {
                this.$refs.editPropertyDialog.showDialog(id);
            },
            viewDeal(dealID){
                this.$refs.viewDeal.showDialog(dealID);
            },
            viewLinks(item){
                this.$refs.viewLinks.showDialog(item);
            },
            editDeal(dealID){
                this.$refs.editDealDialog.showDialog(dealID);
            },

            formatData(data){
                return data.replace(/_/g, ' ');
            },
            formatDate(date){
                // YYYY-MM-DD to DD/MM/YYYY
                return date.split('-').reverse().join('/');
            },
            tableFilter(items){
                // if tabletype = sales, filter out lettings
                if(this.tableType === 'sales'){
                    return items.filter(item => item.deal_type == 'sale');
                }else{
                    return items.filter(item => item.deal_type != 'sale');
                }
            },

            sortData(items, sortBy, sortDesc) {
                if (sortBy.length === 0) {
                    return items
                }

                return items.sort((a, b) => {
                    let sortA = a[sortBy[0]]
                    let sortB = b[sortBy[0]]
                    

                    if (typeof sortA === 'string') {
                        if((sortBy[0] == "created_at" || sortBy[0] == "effective_date")){                         
                            if (sortA) {
                                let dateA = sortA.split('/')
                                sortA = parseFloat(dateA[2] + dateA[1] + dateA[0])
                            } else {
                                if (sortDesc[0]) {
                                    sortA = 0
                                } else {
                                    sortA = 99999999
                                }
                            }
                            if (sortB) {
                                let dateB = sortB.split('/')
                                sortB = parseFloat(dateB[2] + dateB[1] + dateB[0])
                            } else {
                                if (sortDesc[0]) {
                                    sortB = 0
                                } else {
                                    sortB = 99999999
                                }
                            }
                            console.log(sortA, sortB)
                        }else{
                            return sortA.localeCompare(sortB) * (sortDesc[0] ? -1 : 1)
                        }

                    }

                    return (sortA - sortB) * (sortDesc[0] ? -1 : 1)
                })
                
            },
        },
        watch:{
            // pagination: {
            //     handler() {
            //         this.fetchDeals();
            //     },
            //     deep: true
            // },
            tableType(){
                if(this.tableType === 'sales'){
                    this.headers = this.schemeHeaders;
                    // change page to 1
                    this.pagination.page = 1;
                    this.fetchDeals();
                }else{
                    this.headers = this.lettingsHeaders;
                    // change page to 1
                    this.pagination.page = 1;
                    this.fetchDeals();
                }
            },
            dateRange() {
                if (this.dateRange) {
                    // format dates first from YYYY-MM-DD to DD/MM/YYYY
                    let dates = this.dateRange.map(date => {
                        return date.split('-').reverse().join('/')
                    })
                    this.dateRangeText = dates.join(' - ')
                    this.fetchDeals()
                } else {
                    this.dateRangeText = ''
                    this.fetchDeals()
                }
            },

            dealFromDate() {
                if (this.dealFromDate) {
                    let date = this.dealFromDate.split('-').reverse().join('/')
                    this.dealFromText = date

                    this.fetchDeals()
                }else{
                    this.dealFromText = ''
                    this.fetchDeals()
                }
            },

            dealToDate() {
                if (this.dealToDate) {
                    let date = this.dealToDate.split('-').reverse().join('/')
                    this.dealToText = date

                    this.fetchDeals()
                }else{
                    this.dealToText = ''
                    this.fetchDeals()
                }
            }

        },
        mounted(){
            this.fetchDeals();
        }
    }
</script>